// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2UIFD","colMaxWidth":"Table_colMaxWidth__2BvGn"};